export type DesktopNotificationState =
  | "UNSUPPORTED"
  | "BLOCKED"
  | "OFF"
  | "ON";

export function desktopNotificationState(
  supported: boolean,
  permission: NotificationPermission,
  enabled: boolean,
): DesktopNotificationState {
  if (!supported) return "UNSUPPORTED";
  if (permission === "denied") return "BLOCKED";
  return permission === "granted" && enabled ? "ON" : "OFF";
}

export function unseenOpenNotificationIds(
  notifications: Array<{ id: string; status: string }>,
  knownIds: ReadonlySet<string>,
) {
  return notifications
    .filter((item) => item.status === "OPEN" && !knownIds.has(item.id))
    .map((item) => item.id);
}
